import 'css-chunksrc/feature/provision/ProvisionLogin.module.scss';export default {
  "formContainer": "ProvisionLogin_formContainer"
};